/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   10/11/2022
 */

import React from "react";
import { Button, Stack, Typography } from "@mui/material";
import HeroImage from "../../media/images/summaries.svg";
import { Link } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";

export default function NoSummaries() {

	return (
		<Stack justifyContent={"center"} direction={"column"} alignItems={"center"} spacing={2} sx={{ p: 10 }}>
			<Stack>
				<img src={HeroImage} alt={"No notifications"} style={{width: "100px"}} />
			</Stack>
			<Stack>
				<Typography variant="h5">
					{"You haven't configured any summary notifications yet"}
				</Typography>
			</Stack>
			<Stack color="text.secondary">
				<Typography variant="subtitle1">
					{"Get daily summaries in Slack of who is available"}
				</Typography>
			</Stack>
			<Button
				variant={"contained"}
				color={"primary"}
				component={Link}
				to={"/notification/summaries/new"}
				startIcon={<AddIcon />}
			>
				Create Notification
			</Button>
		</Stack>
	);

}